"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
require("../dist/leaflet-ruler");
require("../dist/leaflet-ruler.css");
const react_leaflet_1 = require("react-leaflet");
const leaflet_1 = __importDefault(require("leaflet"));
const Ruler = () => {
    const map = (0, react_leaflet_1.useMap)();
    const rulerRef = (0, react_1.useRef)(null); // Store ruler instance
    (0, react_1.useEffect)(() => {
        if (!map)
            return;
        const ruler = leaflet_1.default.control.ruler();
        rulerRef.current = ruler; // Store in ref for later access
        map.addControl(ruler);
        return () => {
            // Cleanup function to remove ruler when component unmounts
            if (rulerRef.current) {
                map.removeControl(rulerRef.current);
            }
        };
    }, [map]);
    return null;
};
exports.default = Ruler;
